import styled from 'styled-components'

const Container = styled.div`
  .selection--container {
    background: #252841;
    border-radius: 12px;
    padding: 2rem;
    min-width: 600px;
    max-width: 700px;

    @media (max-width: 768px) {
      min-width: 100%;
      padding: 1.5rem;
    }
  }

  header {
    margin-bottom: 2rem;
    text-align: center;

    h2 {
      font-size: 1.75rem;
      font-weight: 600;
      color: #fff;
      margin-bottom: 0.5rem;
    }

    p {
      color: rgba(255, 255, 255, 0.6);
      font-size: 0.95rem;
    }
  }

  .options--grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .option--card {
    background: rgba(255, 255, 255, 0.05);
    border: 2px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 2rem;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    text-align: center;

    &:hover {
      background: rgba(255, 255, 255, 0.08);
      border-color: #4f46e5;
      transform: translateY(-4px);
      box-shadow: 0 8px 24px rgba(79, 70, 229, 0.2);
    }

    .icon--wrapper {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 1.5rem;
      font-size: 1.75rem;

      &.existing {
        background: rgba(16, 185, 129, 0.2);
        color: #10b981;
      }

      &.new {
        background: rgba(79, 70, 229, 0.2);
        color: #4f46e5;
      }
    }

    h3 {
      color: #fff;
      font-size: 1.25rem;
      font-weight: 600;
      margin-bottom: 0.75rem;
    }

    p {
      color: rgba(255, 255, 255, 0.6);
      font-size: 0.9rem;
      line-height: 1.5;
      margin-bottom: 1rem;
    }

    .badge {
      display: inline-block;
      background: #10b981;
      color: #fff;
      font-size: 0.75rem;
      font-weight: 600;
      padding: 0.25rem 0.75rem;
      border-radius: 12px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  }
`

export default Container
